import { Observable, ReplaySubject, throwError, timer } from 'rxjs';
import {
  retry,
  share,
  throttleTime,
} from 'rxjs/operators';

export function cache() {
  return <T>(source: Observable<T>) => {
    const rSubject = new ReplaySubject<T>(1);
    return source.pipe(
      share({
        connector: () => rSubject,
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: true,
      })
    );
  };
}

export function smooth() {
  return <T>(source: Observable<T>) =>
    source.pipe(
      throttleTime(50, undefined, {
        leading: false,
        trailing: true,
      })
    );
}

const DEFAULT_MAX_RETRIES = -1;
const DEFAULT_BACKOFF = 1000;
const DEFAULT_RETRY_DELAY = 2000;
export function retryWithBackoff(
  maxRetry = DEFAULT_MAX_RETRIES,
  delayMs = DEFAULT_RETRY_DELAY,
  backoffMs = DEFAULT_BACKOFF,
  retryableStatuses?: number[]
) {
  return <T>(source: Observable<T>) =>
    source.pipe(
      retry({
        delay: (error, retryCount) => {
          if (retryableStatuses && !retryableStatuses.includes(error.status)) {
            return throwError(() => error);
          }
          const effectiveMaxRetry =
            maxRetry >= 0
              ? maxRetry
              : error.status === 429
              ? 2
              : error.status >= 500
              ? 3
              : 0;
          if (retryCount > effectiveMaxRetry) {
            return throwError(() => error);
          }
          const backoffTime = backoffMs + (retryCount - 1) * delayMs;
          return timer(backoffTime);
        },
      })
    );
}
